ui-cms-article-overview {
  position: relative;

  sd-tag[selected]::part(base) {
    background-color: $sd-backgroundColor-accent-DEFAULT;
    border-color: $sd-backgroundColor-accent-DEFAULT;
  }

  .filter-bar {
    padding: $sd-spacing-8 $sd-spacing-3;
    margin-bottom: $sd-spacing-8;

    .tag-wrapper {
      // center .sd-tag items inside the container
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      gap: $sd-spacing-3 $sd-spacing-3;

      @include breakpoint($medium) {
        width: 40rem;
        margin: 0 auto;
      }

      @include breakpoint($desktop) {
        width: 50rem;
      }
    }
    // remove default styles from button tag
    // button used as a wrapper for .sd-tag for a11y purposes
    button {
      margin: 0;
      padding: 0;
      border: none;
      background: none;

      &:focus {
        outline: none;
      }
    }

    .sd-tag {
      margin-bottom: 0;

      .sd-icon {
        margin-left: $sd-spacing-3;
        width: $sd-spacing-4;
        height: $sd-spacing-4;
        fill: $sd-backgroundColor-white;
      }
    }
  }

  sd-spinner {
    margin: 0 auto;
    display: block;
    font-size: $sd-fontSize-4xl;
  }

  .teasers {
    margin-bottom: $sd-spacing-8;
  }
}
